// Psychologist/PsychologistSpecializations.tsx

import React from 'react';
import {IPsychologist} from '../../Types/psychology/psychologist';
import {useTheme} from 'Theme/ThemeContext';
import {FR} from "WideLayout/Layouts";

interface PsychologistSpecializationsProps {
    psychologist: IPsychologist;
}

const PsychologistSpecializations: React.FC<PsychologistSpecializationsProps> = ({psychologist}) => {
    const {plt} = useTheme();

    return (
        <FR wrap g={1}>
            {psychologist.specializations.map((spec, index) => (
                <span
                    key={index} // Если у спецификации есть уникальный идентификатор, используйте его вместо индекса
                    style={{
                        border: `1px solid ${plt.text.primary20}`,
                        padding: '0 7px',
                        borderRadius: '1rem',
                        color: plt.text.primary60,
                    }}
                >
                    {spec.name}
                </span>
            ))}
        </FR>
    );
};

export default PsychologistSpecializations;
